<img *ngIf="!isLoading && !isError" alt="" width="100%" height="100%" [src]="'data:image/jpeg;base64,'+ image" />
<div *ngIf="isLoading || isError" fxLayout="column" fxLayoutAlign="center center" style="min-height: 200px;min-width: 300px;">
  <mat-spinner *ngIf="isLoading" color="primary" mode="indeterminate" diameter="35"></mat-spinner>
  <p *ngIf="isError" class="error medium">Image fetch failed - {{reason}}</p>
</div>
